import styled from 'styled-components'
import { ThemeColors } from 'src/shared/ui/consts-styles'

export const Container = styled.div`
    display: flex;
    flex-direction: column;
    background-color: white;
    max-height: 100%;
    overflow: hidden;
`

export const EmptyBlock = styled.div`
    font-size: 1.3rem;
    color: ${ThemeColors.red};
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 3rem;
    text-align: center;
`
